module.exports = __webpack_public_path__ + "static/media/mustTry2.4e41b89d.png";